/*
  TICHO homepage analytics — pushes custom events to window.dataLayer (standard GTM
  convention) so they can be wired into GA4 via GTM tags/triggers once a container is
  installed. Standard ecommerce events (view_item, add_to_cart, begin_checkout, purchase,
  etc.) are already emitted natively by Dawn's own product-component/cart/checkout —
  this file only covers the homepage-specific events from the TICHO brief that Shopify's
  native pixel vocabulary doesn't include.
*/
(function () {
  'use strict';

  window.dataLayer = window.dataLayer || [];

  function deviceType() {
    return window.matchMedia('(max-width: 749px)').matches ? 'mobile' : 'desktop';
  }

  function pushEvent(eventName, params) {
    var payload = Object.assign({ event: eventName, device_type: deviceType() }, params || {});
    window.dataLayer.push(payload);
  }

  window.tichoAnalytics = { push: pushEvent };

  function paramsFromTarget(target) {
    var data = target.dataset;
    var params = {};
    if (data.sectionName) params.section_name = data.sectionName;
    if (data.sectionPosition) params.section_position = Number(data.sectionPosition);
    if (data.ctaText) params.cta_text = data.ctaText;
    if (data.categoryName) params.category_name = data.categoryName;
    if (data.productId) params.product_id = data.productId;
    if (data.productName) params.product_name = data.productName;
    return params;
  }

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target.closest && event.target.closest('[data-ticho-event]');
      if (!target) return;
      pushEvent(target.dataset.tichoEvent, paramsFromTarget(target));
    },
    true
  );

  document.addEventListener('ticho:themechange', function (event) {
    if (!event.detail || !event.detail.userInitiated) return;
    pushEvent('day_evening_toggle', { theme: event.detail.theme });
  });

  function observeSectionViews() {
    var sections = document.querySelectorAll('[data-ticho-section-view]');
    if (!sections.length || !('IntersectionObserver' in window)) return;

    var seen = new WeakSet();
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting || seen.has(entry.target)) return;
          seen.add(entry.target);
          observer.unobserve(entry.target);
          var name = entry.target.dataset.tichoSectionView;
          if (!name) return;
          pushEvent('view_homepage_section', {
            section_name: name,
            section_position: Number(entry.target.dataset.tichoSectionPosition || 0)
          });
        });
      },
      { threshold: 0.5 }
    );

    sections.forEach(function (section) {
      observer.observe(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeSectionViews);
  } else {
    observeSectionViews();
  }
})();
